import { useContext } from "react";
import Header from "../components/Header";
import { AuthContext } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import DBGallery from "../components/DBGallery";
import DBNews from "../components/DBNews";
import DBMember from "../components/DBMember";
import DBHomeFigures from "../components/DBHomeFigures";
import DBPublications from "../components/DBPublications";
import DBMembers from "../components/DBMembers";


const PageHomeDB = () => {

    const { isSignIn } = useContext(AuthContext);

    if (false) return <Navigate to="/" />
    return (
        <div hidden={!isSignIn}>
            <Header />
                <br />
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>News Management</Accordion.Header>
                        <Accordion.Body>
                            <DBNews />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Gallery Management</Accordion.Header>
                        <Accordion.Body>
                            <DBGallery />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Figures in Homepage</Accordion.Header>
                        <Accordion.Body>
                            <DBHomeFigures />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Personal Information</Accordion.Header>
                        <Accordion.Body>
                            <DBMember />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Publication Center</Accordion.Header>
                        <Accordion.Body>
                            <DBPublications />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                        <Accordion.Header>Member Management</Accordion.Header>
                        <Accordion.Body>
                            <DBMembers />
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            <br />
        </div>
    )
}


export default PageHomeDB;